export default (companyid, memberid, consultid, groupname) => {  
  if(groupname) {
    if(companyid == '127') { //มหาชัย2
      return `https://tele-cf.dietz-team.workers.dev/${groupname}?openExternalBrowser=1`;
    }
    else {
      return `https://meet.ncdscare.com/${groupname}?openExternalBrowser=1`;
  
    } 

  } else {
    if(companyid == '127') { //มหาชัย2
      return `https://tele-cf.dietz-team.workers.dev/${memberid}/${consultid}?openExternalBrowser=1`;
    }
    else {
      return `https://meet.ncdscare.com/${memberid}/${consultid}?openExternalBrowser=1`;
  
    } 

  }
};